module.exports = __webpack_public_path__ + "img/universal-access.243bde32.svg";